export default "__VITE_ASSET__DxUB1hSz__"